import React, { useState, useEffect } from "react";
import { Form, Input, Button, Icon, Select, Switch } from "antd";
import { MerchantService } from "../../services";
import { handleApiExceptions, alertify, emailValidationRegex } from "../../app_methods";
import { connect } from "react-redux";
import { updateCurrentUserAction } from "../../redux/actions";
import { Text2 } from "../../styles";
import { PermissionHoc } from '../HOC';
import { WebhookDrawer } from "./webhookDrawer";

const PermissableButton = PermissionHoc(Button,"SETTINGS_WRITE_NOTIFICATIONS",{ is_component: true, fallbackComponent: null })

let NotificationForm = (props) => {
	const { form } = props;
	const { getFieldDecorator } = form;
	const [isSaving, setIsSaving] = useState(false);
	const [showDrawer, setShowDrawer] = useState(false);

	useEffect(() => {
		if(!form.getFieldValue("email_enabled")){
			form.validateFields(['emails']);
		}
    }, [form.getFieldValue("email_enabled")]);

	useEffect(() => {
		if(!form.getFieldValue("webhook_enabled")){
			form.validateFields(['webhook_url']);
		}
    }, [form.getFieldValue("webhook_enabled")]);


	const fetchMerchantInfo = () => {
		MerchantService.fetch().then((response) => {
			if (response.success) props.updateCurrentUser(response.data.merchant);
		});
	};

	const emailValidator = (values, callback, required) => {
		const emailRegex = emailValidationRegex();
		const invalidInputs = values.filter((value) => !value.match(emailRegex));
		if (!values) return callback();
		if (invalidInputs.length === 0) {
			callback();
		} else if (invalidInputs.length === 1) {
			callback(invalidInputs.join("") + " is not a valid email");
		} else {
			callback(
				invalidInputs.slice(0, -1).join(", ") +
				" and " +
				invalidInputs.slice(-1) +
				" are not valid emails"
			);
		}
	};

	const webhookUrlValidator = ( value, callback, required) => {
		if (!required || !value) return callback();
	
		const regex = /^(?![0-9\s]*$)(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})+[^\s]$/
		if (!regex.test(value)) {
		  callback("Invalid input");
		} else {
		  callback();
		}
	  };

	const onSubmit = (e) => {
		e.preventDefault();
		form.validateFields(async (err, values) => {
			if (err) return;
			setIsSaving(true);
			const response = await MerchantService.save_notification_settings({
				...values,
				key: props.current_user.key,
			});
			if (!response.success) {
				setIsSaving(false);
				handleApiExceptions(response);
				return;
			}
			alertify("Success", "Settings saved successfully.", "success");
			setIsSaving(false);
			fetchMerchantInfo();
		});
	};

	const toggleWebhookConfigModal = () => {
		setShowDrawer(!showDrawer);
	  };

	return (
		<div className="row">
			<div className="col-sm-12 col-md-12 col-lg-12">
				<Text2 className=" mb-4 mt-2 d-block" strong>
					Transfer Notification
        </Text2>
				<Form onSubmit={onSubmit}>
					<div className="row">
						<div className="col-sm-6 col-md-2 col-lg-2">
							<Form.Item label="Email Enabled">
								{getFieldDecorator("email_enabled", {
									initialValue: props.current_user.notification_setting
										? props.current_user.notification_setting.email_enabled
										: false,
									valuePropName: "checked",
								})(<Switch />)}
							</Form.Item>
						</div>
						<div className="col-sm-6 col-md-10 col-lg-10">
							<Form.Item label="Emails">
								{getFieldDecorator("emails", {
									initialValue: props.current_user.notification_setting
										? props.current_user.notification_setting.emails
										: [],
									rules: [
										{
											validator: (_rule, values, callback)=> emailValidator(values, callback,form.getFieldValue("email_enabled"))

										},
										{ required: props.form.getFieldValue("email_enabled"), message: "Please enter email id" }
									],
								})(
									<Select
										mode="tags"
										tokenSeparators={[","]}
										disabled={!props.form.getFieldValue("email_enabled")}
									/>
								)}
							</Form.Item>
						</div>
					</div>

					<div className="row">
						<div className="col-sm-6 col-md-2 col-lg-2">
							<Form.Item label="Webhook Enabled">
								{getFieldDecorator("webhook_enabled", {
									initialValue: props.current_user.notification_setting
										? props.current_user.notification_setting.webhook_enabled
										: false,
									valuePropName: "checked",
								})(<Switch />)}
							</Form.Item>
						</div>
						<div className="col-sm-6 col-md-10 col-lg-10">
							{/* <Form.Item label="Webhook URL">
								{getFieldDecorator("webhook_url", {
									initialValue: props.current_user.notification_setting
										? props.current_user.notification_setting.webhook_url
										: "",
									rules: [{ required: props.form.getFieldValue("webhook_enabled"), message: "Webhook url is required." },
											{validator: (_rule, values, callback)=> webhookUrlValidator(values, callback,form.getFieldValue("webhook_enabled"))}
										   ],
								})(
									<Input
										autoComplete='off'
										prefix={<Icon type="edit" />}
										disabled={!props.form.getFieldValue("webhook_enabled")}
									/>
								)}
							</Form.Item> */}
							 <Button
								className="p-0 mt-3"
								type="link"
								onClick={()=>{
									setShowDrawer(true);
								}}
								disabled={!props.form.getFieldValue("webhook_enabled")}
							>
								Configure Webhook
							</Button>
						</div>
					</div>
					<div className="w-100 d-flex justify-content-end align-self-end mt-4">
						<PermissableButton type="primary" onClick={onSubmit} loading={isSaving}>
							Save
            </PermissableButton>
					</div>
				</Form>
			</div>
			<WebhookDrawer
				width="70%"
				visible={showDrawer}
				toggleWebhookConfigModal={() =>toggleWebhookConfigModal()}
			/>
		</div>
	);
};

NotificationForm = Form.create()(NotificationForm);
const mapStateToProps = (state) => ({
	current_user: state.userReducer.current_user,
});
const mapDispatchToProps = (dispatch) => ({
	updateCurrentUser: (user) => dispatch(updateCurrentUserAction(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationForm);
